import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Row, Col } from 'antd'
import axios from 'axios'
import AdminHeader from '../../CommonComponents/AdminHeader'
import AdminFooter from '../../CommonComponents/AdminFooter'
import {
  getChildrenList,
  GetCaseFileDataById,
  IMG_URL,
} from '../../APIComponents/AdminApi'

const { Option } = Select

const CaseFileReport = () => {
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [reportData, setReportData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    try {
      const res = await axios.get(getChildrenList)
      setStudents(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchReport = async () => {
    if (!selectedStudent) return

    setLoading(true)
    try {
      const res = await axios.get(`${GetCaseFileDataById}/${selectedStudent}`)
      setReportData(res.data)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const getCaseType = (val) => {
    switch (val) {
      case 1:
        return 'फौजदारी'
      case 2:
        return 'नागरी'
      default:
        return '-'
    }
  }

  const isPDF = (file) => {
    return file?.toLowerCase().endsWith('.pdf')
  } 

  const renderImage = (label, file) => {
    return (
      <div className="mb-3">
        <p>
          <b>{label}</b>
        </p>
        {file ? (
          isPDF(file) ? (
            <iframe
              src={`${IMG_URL}${file}`}
              title="PDF Viewer"
              className="pdf-viewer"
            />
          ) : (
            <img
              src={`${IMG_URL}${file}`}
              className="doc-img"
              alt="home-visit"
            />
          )
        ) : (
          <p>उपलब्ध नाही</p>
        )}
      </div>
    )
  }

  return (
    <>
      <AdminHeader />

      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">Case File Report</h3>
          </div>

          <Row gutter={16} className="mb-3 shadow rounded py-3 m-0 bg-white">
            <Col md={8}>
              <Select
                className="w-100"
                placeholder="Select Student"
                onChange={(val) => setSelectedStudent(val)}
              >
                {students.map((child) => (
                  <Option key={child.id} value={child.id}>
                    {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                    {child.reg_no})
                  </Option>
                ))}
              </Select>
            </Col>

            <Col md={8}>
              <Button type="primary" onClick={fetchReport}>
                Show Report
              </Button>

              <Button style={{ marginLeft: 10 }} onClick={() => window.print()}>
                Print
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin size="large" />
          ) : reportData ? (
            <div className="a4-page">
              {/* HEADER */}
              <div className="text-center pb-3">
                <h2>
                  <b>सेंट क्रिस्पिन्स होम</b>
                </h2>
                <h5>
                  <b>केस फाईल अहवाल</b>
                </h5>
              </div>

              {/* CASE DETAILS */}
              <div className="section">
                <div className="row p-0 m-0">
                  <div className="col-12">
                    <p>
                      <b>विद्यार्थ्याचे नाव:</b> {reportData.student.full_name}
                    </p>
                  </div>

                  <div className="col-12 col-md-6">
                    <p>
                      <b>केस क्रमांक:</b> {reportData.case_number}
                    </p>
                  </div>
                  <div className="col-12 col-md-6">
                    <p>
                      <b>नोंदणी तारीख:</b> {reportData.case_registration_date}
                    </p>
                  </div>
                  <div className="col-12 col-md-6">
                    <p>
                      <b>केस प्रकार:</b> {getCaseType(reportData.case_type)}
                    </p>
                  </div>
                  <div className="col-12">
                    <p>
                      <b>संदर्भ देणारे:</b> {reportData.referred_by}
                    </p>
                  </div>
                  <div className="col-12 col-md-6">
                    <p>
                      <b>हाताळणारे:</b> {reportData.handled_by}
                    </p>
                  </div>
                  <div className="col-12">
                    <p>
                      <b>पोलीस स्टेशन:</b> {reportData.police_station_name}
                    </p>
                  </div>
                  <div className="col-12">
                    <p>
                      <b>तपशील:</b> {reportData.description}
                    </p>
                  </div>
                </div>
              </div>

              {/* DOCUMENTS */}
              <div className="section">
                {renderImage('1) FIR रिपोर्ट:', reportData.fir_report)}
                {renderImage('2) CWC आदेश:', reportData.cwc_order)}
                {renderImage('3) स्टेटमेंट कॉपी:', reportData.statement_copy)}
                {renderImage('4) कायदेशीर नोटीस:', reportData.legal_notice)}
                {renderImage(
                  '5) सामाजिक तपास अहवाल:',
                  reportData.social_investigation_report,
                )}
                {renderImage(
                  '6) इतर कागदपत्रे:',
                  reportData.other_supporting_documents,
                )}
              </div>
            </div>
          ) : (
            <p style={{ padding: 20 }}>No Data Found</p>
          )}
        </div>
      </div>

      <AdminFooter />

      {/* CSS */}
      <style>{`
        .a4-page {
          width: 210mm;
          min-height: 297mm;
          padding: 20px 60px;
          background: white;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .section {
          margin-bottom: 20px;
        }

        .section p {
          color: black;
        }

        .text-center {
          text-align: center;
        }

        .doc-img {
          width: 100%;
          height: auto;
          max-height: 500px;
          object-fit: contain;
          margin-bottom: 15px;
          border: 1px solid black;
        }

        @media print {
          body * {
            visibility: hidden;
          }

          .a4-page, .a4-page * {
            visibility: visible;
          }

          .a4-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 210mm;
          }

          .doc-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .section {
            page-break-inside: avoid;
          }

          .row {
            display: flex !important;
            flex-wrap: wrap !important;
          }

          .col-md-6 {
            width: 50% !important;
            float: left !important;
          }

          .col-md-4 {
            width: 33.33% !important;
            float: left !important;
          }

          .col-md-8 {
            width: 66.66% !important;
            float: left !important;
          }

          .col-md-12 {
            width: 100% !important;
            float: left !important;
          }

          .row > div {
            padding: 2px !important;
          }
        }
      `}</style>
    </>
  )
}

export default CaseFileReport
